import * as Joi from "joi";
import { Column, Entity, JoinColumn, ManyToOne } from 'typeorm';
import { GenPartial } from 'typeormgen';
import { COLORS } from '../enums/enums';
import EpisodicItem from '../episodic-items/episodic-item.entity';
import PictureRelation from '../picture-relations/picture-relation.entity';
import Picture from '../pictures/picture.entity';

@Entity('cm_episodic_item_pictures')
export default class CmEpisodicItemPicture extends PictureRelation {
	static tableName = 'cm_episodic_item_pictures';

	@Column('int')
	episodic_id: number;

	@Column('int')
	episodic_item_id: number;

	@ManyToOne(
		(type) => EpisodicItem,
		(episodicItem) => episodicItem.cmEpisodicItemPictures
	)
	@JoinColumn({
		name: 'episodic_item_id',
	})
	episodicItem: EpisodicItem;

	@ManyToOne((type) => Picture, (picture) => picture.cmEpisodicItemPictures)
	@JoinColumn({
		name: 'picture_id',
	})
	picture: Picture;

	static rules() {
		return {
			...super.rules(),
			episodic_id: Joi.number().integer(),
			episodic_item_id: Joi.number().integer(),
		};
	}

	toJSON() {
		return {
			...super.toJSON(),
			episodic_item_id: this.episodic_item_id,
			episodic_id: this.episodic_id,
		};
	}

	constructor(props?: GenPartial<CmEpisodicItemPicture>) {
		super(props);
	}

	getTagColor() {
		return COLORS.INVENTORY_LIGHT;
	}

	getTagRemoveColor() {
		return COLORS.INVENTORY;
	}
}
